import React from 'react'
import connect from 'front-end-core/decorators/connect'
import { requestClarilisDocs } from 'services/PrecedentsService'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import SkeletonTiles from 'components/tiled-menu/SkeletonTiles'
import TiledMenu from 'components/tiled-menu/TiledMenu'

const ContentOverride = ({ marketingLink }) => (
  <div className='ml6 mb6'>
    Learn more <a href={marketingLink}>here</a>.
  </div>
)

const ClarilisTileMenu = ({ suites, cxNames }) => {
  const tiledMenu = {
    rootSections: suites.map(({ title, actionLink, marketingLink }) => ({
      id: actionLink,
      title,
      active: true,
      getUrl: () => actionLink,
      contentOverride: <ContentOverride {...{ marketingLink }} />
    }))
  }
  return (
    <TiledMenu
      {...{ tiledMenu, cxNames }}
      data-help-item='automateddocumenttiles'
      data-help-position='middle'
      category='Automated Documents Clarilis'
      setTiledMenuIsLoaded={() => null}
      ignoreNodes
    />
  )
}

export default connect(() => ({
  suites: requestClarilisDocs()
}))(({ suites, cxNames }) =>
  <ResponseConsumer
    response={suites}
    content={() => <ClarilisTileMenu {...{ suites, cxNames }} />}
    pendingComponent={SkeletonTiles}
  />
)
